import {Injectable} from '@angular/core';
import {RoutesAddonsEnums, RoutesNamesEnum} from '../../../enums/RoutesEnums';
import {UrlTermsSymbolsEnum} from '../../../enums/SeoEnums';
import {WidgetDataTypeEnum} from '../../../enums/WidgetDataTypeEnum';
import {CategoryConfig} from '../types/CategoryConfig';

// Type for only the related route addons
type RelatedRoutesAddonsEnums =
  | RoutesAddonsEnums.RELATED_CAREPROVIDER
  | RoutesAddonsEnums.RELATED_CARESERVICE
  | RoutesAddonsEnums.RELATED_SYMPTOM;

@Injectable({
  providedIn: 'root',
})
export class RelatedCategoryConfigService {
  private readonly categoryConfigs: Record<RelatedRoutesAddonsEnums, CategoryConfig> = {
    [RoutesAddonsEnums.RELATED_CARESERVICE]: {
      typeName: RoutesNamesEnum.RELATED_CARESERVICE,
      dataKey: 'careServiceTypes',
      addon: UrlTermsSymbolsEnum.SERVICE_TYPE,
      widgetDataType: WidgetDataTypeEnum.CARE_SERVICE_TYPES,
      introText: '',
      h1Title: `Relaterade sökningar på ${RoutesNamesEnum.RELATED_CARESERVICE}`,
    },
    [RoutesAddonsEnums.RELATED_SYMPTOM]: {
      typeName: RoutesNamesEnum.RELATED_SYMPTOM,
      dataKey: 'symptoms',
      addon: UrlTermsSymbolsEnum.SYMPTOM,
      widgetDataType: WidgetDataTypeEnum.SYMPTOMS,
      introText: '',
      h1Title: `Relaterade sökningar på ${RoutesNamesEnum.RELATED_SYMPTOM}`,
    },
    [RoutesAddonsEnums.RELATED_CAREPROVIDER]: {
      typeName: RoutesNamesEnum.RELATED_CAREPROVIDER,
      dataKey: 'caregiverUnitTypes',
      addon: UrlTermsSymbolsEnum.CAREPROVIDER_UNIT_TYPE,
      widgetDataType: WidgetDataTypeEnum.CAREGIVER_UNIT_TYPES,
      introText:
        'Välkommen till Sveriges största samling av legitimerade vårdgivare! Här kan du jämföra, ' +
        'lista dig och boka tid hos vårdcentraler, tandläkare, psykologer, naprapater, kiropraktorer, hudläkare ' +
        'och ögonläkare. Se omdömen, betyg och hitta de bästa vårdalternativen nära dig. Oavsett vilken vård du ' +
        'söker hjälper vi dig att göra ett informerat val.',
      h1Title: 'Jämför och Boka Sveriges Bästa Legitimerade Vårdgivare',
    },
  };

  public getCategoryConfig(categoryType: RoutesAddonsEnums): CategoryConfig {
    return (
      this.categoryConfigs[categoryType as RelatedRoutesAddonsEnums] ||
      this.categoryConfigs[RoutesAddonsEnums.RELATED_CAREPROVIDER]
    );
  }

  public getAllCategoryTypes(): RelatedRoutesAddonsEnums[] {
    return Object.keys(this.categoryConfigs) as RelatedRoutesAddonsEnums[];
  }
}
